import './App.css';
import './Adaptation.css'
import Menu from "./Menu";

function App() {
    return (
        <div className="App">
            <Menu/>
        </div>
    );
}

export default App;
